import { generateApiRoute } from '@klp/core/api/helpers';
import { baseApi } from '@klp/core/api';
import { byggApiName, kommentarerApiName } from '../config';

export type IKommentar = {
    id?: string;
    byggNummer: string;
    oppdatert?: string;
    kategori?: string;
    tittel?: string;
    framhevet?: boolean;
    sammendrag?: string;
    tekst?: string;
    created?: string;
    gjelderForAar?: string;
    oppdatertAv?: string;
    oppdatertAvBruker?: IKommentarBruker;
    avkortetSammendrag?: boolean;
    createdAvBruker?: IKommentarBruker;
};

type IKommentarBruker = {
    navn?: string;
    fornavn?: string;
    etternavn?: string;
};

type IKommentarer = Array<IKommentar>;

export const kommentarerApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getKommentarer: build.query<
            IKommentarer,
            {
                byggNummer: string;
                kunfremhevde?: boolean;
                gjelderForAar?: string;
                kategori?: string;
                maksTegn?: number;
                maksAntallKommentarer?: number;
            }
        >({
            query: ({
                byggNummer,
                kunfremhevde,
                gjelderForAar,
                kategori,
                maksTegn,
                maksAntallKommentarer,
            }) => ({
                url: generateApiRoute([
                    byggApiName,
                    kommentarerApiName,
                    byggNummer,
                ]),
                method: 'GET',
                params: {
                    kunfremhevde,
                    gjelderForAar,
                    kategori,
                    maksAntallKommentarer,
                    maksTegn,
                },
            }),
            providesTags: (result, error, arg) => {
                if (arg?.kunfremhevde) {
                    return ['KommentarerFremhevede'];
                }
                return ['Kommentarer'];
            },
        }),
        getKommentar: build.query<
            IKommentar,
            { byggNummer: string; id: string }
        >({
            query: ({ byggNummer, id }) => ({
                url: generateApiRoute([
                    byggApiName,
                    kommentarerApiName,
                    byggNummer,
                    id,
                ]),
                method: 'GET',
            }),
        }),
        postKommentar: build.mutation<IKommentar, IKommentar>({
            query(data) {
                return {
                    url: generateApiRoute([byggApiName, kommentarerApiName]),
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['Kommentarer', 'KommentarerFremhevede'],
        }),
        deleteKommentar: build.mutation<
            IKommentar,
            { byggNummer: string; id: string }
        >({
            query(data) {
                const { byggNummer, id } = data;
                return {
                    url: generateApiRoute([
                        byggApiName,
                        kommentarerApiName,
                        byggNummer,
                        id,
                    ]),
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['Kommentarer', 'KommentarerFremhevede'],
        }),
    }),
});
export const {
    useLazyGetKommentarerQuery,
    useGetKommentarerQuery,
    useDeleteKommentarMutation,
    useGetKommentarQuery,
    useLazyGetKommentarQuery,
    usePostKommentarMutation,
} = kommentarerApi;
